export default function (value) {
  this.$emit('input', value)
}
